import React from "react";

function PumaGenEWeekend() {
  return (
    <main className="w-full min-h-screen text-fordBlue font-fordAntennaRegular">
      <section className="w-full">
        <img
          src="/images/pumaTehnomarket/PumaTechnomarket-mobile.jpg"
          alt="Ford Puma Gen-E кампания"
          className="block w-full h-auto md:hidden"
        />
        <img
          src="/images/pumaTehnomarket/PumaTechnomarket-desktop.jpg"
          alt="Ford Puma Gen-E кампания"
          className="hidden w-full h-auto md:block"
        />
      </section>

      <section className="max-w-[1120px] px-4 py-8 mx-auto md:px-10 md:py-14">
        <h1 className="max-w-5xl mx-auto text-3xl text-center uppercase md:text-5xl font-fordAntennaBold">
          ВКЛЮЧИ СЕ В ПРОЛЕТНАТА ИГРА НА FORD И ТЕХНОМАРКЕТ И СПЕЧЕЛИ УИКЕНД
          ТЕСТ-ДРАЙВ С PUMA GEN-E
        </h1>

        <div className="grid grid-cols-1 gap-6 mt-8 leading-relaxed md:grid-cols-2 md:gap-10 md:mt-12">
          <p>
            Техномаркет и Ford обединяват сили в специална пролетна игра, която
            ще ви донесе незабравими преживявания. От 2 март до 12 април имате
            възможността да се включите и да спечелите атрактивни награди,
            включително уикенд тест-драйв с новия електрически Ford Puma Gen-E.
          </p>
          <p>
            Участието е лесно. Просто последвайте Facebook страницата на Ford
            Bulgaria, посетете пролетния кът с Puma Gen-E в Техномаркет на бул.
            „Цариградско шосе“, гр. София и си направете снимка. След това
            публикувайте своята снимка като коментар под{" "}
            <a
              href="https://www.facebook.com/photo?fbid=1368210695334420&set=a.627894492699381"
              target="_blank"
              rel="noreferrer"
              className="underline transition text-fordBlue hover:text-fordBlue/80"
            >
              официалната публикация на страницата
            </a>
            . С това гарантирате своето участие в томболата за наградите.
          </p>
        </div>
      </section>

      <section className="max-w-[1120px] px-4 pb-8 mx-auto md:px-10 mt-20 md:pb-16">
        <h2 className="text-3xl text-center uppercase md:text-5xl font-fordAntennaBold">
          Награден фонд
        </h2>
        <p className="mt-2 text-base text-center md:text-xl">
          В рамките на кампанията участниците ще имат възможност да спечелят:
        </p>

        <div className="grid items-center grid-cols-1 gap-6 md:grid-cols-2 md:gap-12">
          <img
            src="/images/pumagene-suv5vrati-gene-electricyellow.jpeg"
            alt="Puma Gen-E жълт"
            className="w-full h-auto"
          />
          <div>
            <h3 className="text-2xl leading-tight uppercase md:text-2xl font-fordAntennaBold">
              I-ва награда: Уикенд тест-драйв с Puma Gen-E
            </h3>
            <p className="mt-4 text-sm leading-relaxed">
              В рамките на един уикенд ще можете да се насладите на пълноценно
              изживяване зад волана на изцяло електрическия модел.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 mt-4 md:grid-cols-2 md:gap-12">
          <div>
            <h3 className="text-2xl leading-tight uppercase md:text-2xl font-fordAntennaBold">
              II-а награда: Оригинална туристическа раница Ford
            </h3>
            <p className="mt-3 text-sm leading-relaxed">
              Стилен и функционален аксесоар, създаден за активното ежедневие и
              пътуванията извън града.
            </p>
          </div>
          <div>
            <h3 className="text-2xl leading-tight uppercase md:text-2xl font-fordAntennaBold">
              III-та награда: Брандирана бутилка Ford
            </h3>
            <p className="mt-3 text-sm leading-relaxed">
              Функционален аксесоар, подходящ за преходи, пикници и активни дни
              на открито. Идеалното допълнение към всяко пролетно приключение.
            </p>
          </div>
        </div>

        <div className="flex justify-center mt-10 md:mt-14">
          <a
            href="https://sale.ford.bg/pumatermsandconditions"
            target="_blank"
            rel="noreferrer"
            className="px-8 py-3 text-base border rounded-full md:text-lg font-fordMedium border-[#2F36FF] text-[#2F36FF] hover:bg-[#2F36FF] hover:text-white transition"
          >
            Виж пълните условия на играта
          </a>
        </div>
      </section>

      <section className="max-w-[11200px] px-4 pt-6 pb-12 mx-auto md:px-10 md:pt-10 md:pb-20">
        <p className="text-4xl leading-tight md:text-4xl md:leading-[1.5]">
          Puma Gen-E е създаден за съвременния градски ритъм. Изцяло
          електрическото задвижване осигурява плавно и тихо управление, а
          интелигентно организираното пространство с вместимост до 566 литра,
          включително Gigabox и преден багажник (frunk), гарантира практичност
          без компромис.
        </p>

        <div className="relative mt-8 overflow-hidden rounded-[32px] md:rounded-[44px]">
          <img
            src="/images/pumaTehnomarket/puma-gen-e-yellow.jpg"
            alt="Ford Puma Gen-E отпред"
            className="object-cover w-full h-auto"
          />
          <div className="absolute inset-x-0 flex justify-center bottom-8 md:bottom-14">
            <a
              href="https://ford.bg/cars/puma-gen-e"
              target="_blank"
              rel="noreferrer"
              className="px-8 py-3 text-sm text-white transition-all duration-300 border border-white rounded-full md:text-base font-fordMedium bg-white/10 backdrop-blur-sm hover:bg-white hover:text-fordBlue hover:shadow-lg hover:scale-105"
            >
              Научете повече за модела
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default PumaGenEWeekend;
